<template>
  <div :class="{ 'web-header': true, 'en-font': language == 'en', 'cn-font': language == 'cn' }">
    <div class="web-header-top">
      <div class="web-header-top-box">
        <div class="web-header-top-box-card">
          <a href="https://www.cf40.org.cn/" target="_blank" class="web-header-top-box-card-link" v-if="language == 'cn'">
            <div class="web-header-top-box-card-link-icon">
              <img src="~@/assets/cf40.png" />
            </div>
            <span class="web-header-top-box-card-link-text">中国金融四十人论坛</span>
          </a>
          <a href="https://en.cf40.com/" target="_blank" class="web-header-top-box-card-link" v-else>
            <div class="web-header-top-box-card-link-icon">
              <img src="~@/assets/cf40.png" />
            </div>
            <span class="web-header-top-box-card-link-text roboto-light">CHINA FINANCE 40 FORUM</span>
          </a>
          <a href="/en" class="web-header-top-box-card-switch" v-if="language == 'cn'">
            EN
          </a>
          <a href="/" class="web-header-top-box-card-switch roboto-light" v-else>
            CN
          </a>
        </div>
      </div>
    </div>
    <div class="web-header-content">
      <div :class="{ 'web-header-content-box': true, 'is-login': info.mobile || info.email }">
        <a href="/" class="web-header-content-box-cn_logo" v-if="language == 'cn'">
          <img src="~@/assets/chinese_logo.png" alt="CF40 研究" />
        </a>
        <a href="/en" class="web-header-content-box-en_logo" v-else>
          <img src="~@/assets/english_logo.png" alt="CF40 RESEARCH" />
        </a>
        <div class="web-header-content-box-opera">
          <div class="web-header-content-box-opera-search" v-if="searchVisible">
            <el-input v-model.trim="keywords" prefix-icon="el-icon-search" :placeholder="language == 'cn' ? '请输入关键词' : 'keywords'" @keyup.native.enter="searchData" @clear="searchData" clearable></el-input>
          </div>
          <div class="web-header-content-box-opera-user" v-if="info.mobile || info.email">
            <div ref="accountArea" class="account-area" @mouseleave="accountVisible = false" @focusout="handleAccountFocusOut" @keydown.esc.stop="closeAccountPanel">
              <button ref="accountButton" type="button" class="account-link" :aria-expanded="String(accountVisible)" :aria-label="language === 'en' ? 'Personal Information' : '个人信息'" @click="accountVisible = !accountVisible">
                <i class="el-icon-user" aria-hidden="true"></i>
                <span class="account">{{ info.email || info.mobile }}</span>
                <i :class="accountVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" aria-hidden="true"></i>
              </button>
              <div v-if="accountVisible" class="account-panel-wrap">
                <section class="account-panel" :aria-label="language === 'en' ? 'Personal Information' : '个人信息'">
                  <h2>{{ language === 'en' ? 'Personal Information' : '个人信息' }}</h2>
                  <dl class="account-information">
                    <div><dt>{{ language === 'en' ? 'Email' : '邮箱' }}</dt><dd>{{ info.email || emptyContact }}</dd></div>
                    <div><dt>{{ language === 'en' ? 'Mobile' : '手机号' }}</dt><dd>{{ info.mobile || emptyContact }}</dd></div>
                    <div><dt>{{ language === 'en' ? 'Institution' : '所属机构' }}</dt><dd>{{ institutionName || (language === 'en' ? 'No institution' : '暂无机构') }}</dd></div>
                    <div><dt>{{ language === 'en' ? 'Membership Level' : '会员等级' }}</dt><dd>{{ membershipName }}</dd></div>
                    <div><dt>{{ language === 'en' ? 'Membership Expiry' : '会员到期日' }}</dt><dd>{{ membershipExpiry }}</dd></div>
                  </dl>
                  <div class="account-actions">
                    <el-button type="text" @click="openPassword">{{ language === 'en' ? 'Change Password' : '修改密码' }}</el-button>
                    <el-button type="text" :loading="loggingOut" @click="logoutHandle">{{ language === 'en' ? 'Log Out' : '退出登录' }}</el-button>
                  </div>
                </section>
              </div>
            </div>
            <!-- 暂时隐藏导航栏订阅入口（已登录态）
            <span class="web-header-content-box-opera-user-link cn-font-bold" @click="subscribe" v-if="language == 'cn'">订阅</span>
            <span class="web-header-content-box-opera-user-link roboto-bold" @click="subscribe" v-else>SUBSCRIBE</span>
            -->
          </div>
          <template v-else>
            <div class="web-header-content-box-opera-user">
              <div class="web-header-content-box-opera-login cn-font-bold" @click="login" v-if="language == 'cn'">
                登录
              </div>
              <div class="web-header-content-box-opera-login roboto-bold" @click="login" v-else>
                SIGN IN
              </div>
              <!-- 暂时隐藏导航栏订阅入口（未登录态）
              <div class="web-header-content-box-opera-subscribe cn-font-bold" @click="subscribe" v-if="language == 'cn'">
                订阅
              </div>
              <div class="web-header-content-box-opera-subscribe roboto-bold" @click="subscribe" v-else>
                SUBSCRIBE
              </div>
              -->
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="info.must_change_password" class="initial-password-notice">
      {{ language === 'en' ? 'Please change your temporary password.' : '请首次登录后点击右上角账号，在个人信息中修改初始密码。' }}
      <el-button type="text" @click="openPassword">{{ language === 'en' ? 'Change Password' : '修改密码' }}</el-button>
    </div>
    <el-dialog class="cf40-password-dialog-wrap" custom-class="cf40-password-dialog" modal-class="cf40-password-dialog-mask" :title="language === 'en' ? 'Change Password' : '修改密码'" :visible.sync="passwordVisible" :show-close="false" width="410px" append-to-body @closed="resetPasswordForm">
      <template slot="title">
        <span class="el-dialog__title">{{ language === 'en' ? 'Change Password' : '修改密码' }}</span>
        <button type="button" class="cf40-password-close" :aria-label="language === 'en' ? 'Close' : '关闭'" @click="passwordVisible = false">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="8.33" /><path d="m7.64 7.64 4.72 4.72m0-4.72-4.72 4.72" /></svg>
        </button>
      </template>
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-position="top" hide-required-asterisk @submit.native.prevent="submitPassword">
        <el-form-item :label="language === 'en' ? 'New Password' : '新密码'" prop="new_password">
          <template slot="label">{{ language === 'en' ? 'New Password' : '新密码' }}<span class="cf40-password-required" aria-hidden="true">*</span></template>
          <el-input v-model="passwordForm.new_password" :type="passwordShown ? 'text' : 'password'" :placeholder="language === 'en' ? 'Enter your new password (6–16 characters)' : '请输入6-16位新密码'" autocomplete="new-password" @keyup.enter.native="submitPassword">
            <button slot="suffix" type="button" class="cf40-password-toggle" :aria-label="language === 'en' ? (passwordShown ? 'Hide new password' : 'Show new password') : (passwordShown ? '隐藏新密码' : '显示新密码')" :aria-pressed="String(passwordShown)" @click="passwordShown = !passwordShown">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><template v-if="passwordShown"><path d="M1.33 8s2-4 6.67-4 6.67 4 6.67 4-2 4-6.67 4-6.67-4-6.67-4Z" /><circle cx="8" cy="8" r="1.67" /></template><path v-else d="M2 5.33s2 2.67 6 2.67 6-2.67 6-2.67M3.55 7.12 1.67 9M6.33 8l-.69 2.58M9.66 8l.69 2.58M12.45 7.12 14.33 9" /></svg>
            </button>
          </el-input>
        </el-form-item>
        <el-form-item :label="language === 'en' ? 'Confirm New Password' : '确认新密码'" prop="confirm_password">
          <template slot="label">{{ language === 'en' ? 'Confirm New Password' : '确认新密码' }}<span class="cf40-password-required" aria-hidden="true">*</span></template>
          <el-input v-model="passwordForm.confirm_password" :type="confirmPasswordShown ? 'text' : 'password'" :placeholder="language === 'en' ? 'Re-enter your new password (6–16 characters)' : '请再次输入6-16位新密码'" autocomplete="new-password" @keyup.enter.native="submitPassword">
            <button slot="suffix" type="button" class="cf40-password-toggle" :aria-label="language === 'en' ? (confirmPasswordShown ? 'Hide confirmed password' : 'Show confirmed password') : (confirmPasswordShown ? '隐藏确认密码' : '显示确认密码')" :aria-pressed="String(confirmPasswordShown)" @click="confirmPasswordShown = !confirmPasswordShown">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><template v-if="confirmPasswordShown"><path d="M1.33 8s2-4 6.67-4 6.67 4 6.67 4-2 4-6.67 4-6.67-4-6.67-4Z" /><circle cx="8" cy="8" r="1.67" /></template><path v-else d="M2 5.33s2 2.67 6 2.67 6-2.67 6-2.67M3.55 7.12 1.67 9M6.33 8l-.69 2.58M9.66 8l.69 2.58M12.45 7.12 14.33 9" /></svg>
            </button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="cf40-password-actions">
        <el-button @click="passwordVisible = false">{{ language === 'en' ? 'Cancel' : '取消' }}</el-button>
        <el-button type="primary" :loading="passwordSaving" @click="submitPassword">{{ language === 'en' ? 'Submit' : '提交' }}</el-button>
      </div>
    </el-dialog>
    <login-chinese ref="loginChineseRef" @success="loginSuccess"></login-chinese>
    <login-english ref="loginEnglishRef" @success="loginSuccess"></login-english>
  </div>
</template>

<script>
import LoginChinese from "../loginChinese";
import LoginEnglish from "../loginEnglish";
import { userInfo, logoutSystem, changePcPassword } from "@/api";
export default {
  name: "WebHeader",
  components: {
    LoginChinese,
    LoginEnglish
  },
  props: {
    language: {
      type: String,
      default: "en"
    },
    searchVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      info: {},
      accountRequest: 0,
      accountVisible: false,
      institutionName: '',
      memberCategoryName: '',
      loggingOut: false,
      passwordVisible: false,
      passwordSaving: false,
      passwordShown: false,
      confirmPasswordShown: false,
      passwordForm: { new_password: '', confirm_password: '' },
      keywords: "",
    };
  },
  computed: {
    emptyContact() { return this.language === 'en' ? 'Not linked' : '未绑定'; },
    membershipName() {
      if (!Number(this.info.vip_level)) return this.language === 'en' ? 'No active membership' : '暂无会员';
      // 一级分类独立返回，不展示试用、年费等等级说明。
      return this.memberCategoryName || (this.language === 'en' ? 'Member' : '会员');
    },
    membershipExpiry() {
      const date = String(this.info.vip_expire || '').match(/^(\d{4}-\d{2}-\d{2})(?:[ T]|$)/);
      return date ? date[1] : '—';
    },
    passwordRules() {
      const en = this.language === 'en';
      return {
        new_password: [{ required: true, min: 6, max: 16, message: en ? 'Enter a password of 6 to 16 characters' : '请输入6至16位新密码', trigger: 'blur' }],
        confirm_password: [{ validator: (rule, value, callback) => callback(value && value === this.passwordForm.new_password ? undefined : new Error(en ? 'The passwords do not match' : '两次密码不一致')), trigger: 'blur' }]
      };
    }
  },
  created() {
    if (this.$route.query.keywords) {
      this.keywords = decodeURIComponent(this.$route.query.keywords);
    }
    this.getUserInfo();
  },
  mounted() { document.addEventListener('click', this.handleAccountOutside); },
  beforeDestroy() {
    ++this.accountRequest;
    document.removeEventListener('click', this.handleAccountOutside);
  },
  watch: {
    '$route.query.login': {
      immediate: true,
      handler(value) {
        if (value !== '1') return;
        this.clearAccount();
        this.$nextTick(() => {
          this.login();
          const query = { ...this.$route.query };
          delete query.login;
          this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash });
        });
      }
    }
  },
  methods: {
    clearAccount() {
      this.$emit('account-session-change');
      ++this.accountRequest;
      this.info = {};
      this.institutionName = '';
      this.memberCategoryName = '';
      this.accountVisible = false;
    },
    handleAccountOutside(event) {
      if (this.$refs.accountArea && !this.$refs.accountArea.contains(event.target)) this.accountVisible = false;
    },
    handleAccountFocusOut(event) {
      if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) this.accountVisible = false;
    },
    closeAccountPanel() {
      this.accountVisible = false;
      if (this.$refs.accountButton) this.$refs.accountButton.focus();
    },
    openPassword() {
      this.accountVisible = false;
      this.passwordVisible = true;
    },
    login() {
      if (this.language == "cn") {
        this.$refs.loginChineseRef.open();
      } else {
        this.$refs.loginEnglishRef.open();
      }
    },
    reloadPage() {
      let links = window.location.href;
      const newUrl = window.location.origin + window.location.pathname;
      if (links.indexOf("report/english") || links.indexOf("report/chinese")) {
        window.location.href = newUrl;
      } else if (links.indexOf("equity/english") || links.indexOf("equity/chinese")) {
        window.location.href = newUrl;
      }
    },
    async getUserInfo() {
      const request = ++this.accountRequest;
      const token = localStorage.getItem('cf40-token');
      if (!token) { this.clearAccount(); return; }
      try {
        const res = await userInfo({}, this.language === 'en');
        if (request !== this.accountRequest) return;
        if (localStorage.getItem('cf40-token') !== token) {
          this.clearAccount();
          return;
        }
        if (res && res.code === 200 && res.data && res.data.user_info) {
          this.info = res.data.user_info;
          this.$emit('account-session-change');
          this.institutionName = res.data.institution_name || '';
          this.memberCategoryName = String(res.data.member_category_name || '').trim();
          return;
        }
      } catch (error) { /* 请求层显示错误，不能保留失效账号资料。 */ }
      if (request !== this.accountRequest) return;
      this.clearAccount();
    },
    async loginSuccess() {
      await this.getUserInfo();
      if (this.$listeners['session-change']) this.$emit('session-change');
      else this.reloadPage();
    },
    resetPasswordForm() {
      this.passwordForm = { new_password: '', confirm_password: '' };
      this.passwordShown = false;
      this.confirmPasswordShown = false;
      if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate();
    },
    submitPassword() {
      if (this.passwordSaving) return;
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) return;
        this.passwordSaving = true;
        try {
          const res = await changePcPassword(this.passwordForm, this.language === 'en');
          if (res && res.code === 200) {
            localStorage.removeItem('cf40-token');
            this.clearAccount();
            this.passwordVisible = false;
            this.$message.success(this.language === 'en' ? 'Password changed. Please sign in again.' : '密码修改成功，请重新登录。');
            this.$emit('session-change');
            this.login();
          }
        } catch (error) { /* 请求层显示失败信息。 */ }
        finally {
          this.passwordSaving = false;
          if (!localStorage.getItem('cf40-token')) this.clearAccount();
        }
      });
    },
    async logoutHandle() {
      if (this.loggingOut) return;
      this.loggingOut = true;
      try {
        const res = await logoutSystem(this.language === 'en');
        if (!res || res.code !== 200) return;
        localStorage.removeItem('cf40-token');
        this.clearAccount();
        this.$message.success(this.language === 'en' ? 'Logged out' : '退出成功');
        if (this.$listeners['session-change']) this.$emit('session-change');
        else window.location.reload();
      } catch (error) { /* 网络异常允许重试，错误由请求层提示。 */ }
      finally {
        this.loggingOut = false;
        if (!localStorage.getItem('cf40-token')) this.clearAccount();
      }
    },
    subscribe() {
      if (this.language == "cn") {
        this.routerLink('/equity/chinese', true);
      } else {
        this.routerLink('/equity/english', true);
      }
    },
    searchData() {
      if (this.language == "en") {
        if (this.keywords) {
          this.$router.push({ name: 'English', query: { keywords: encodeURIComponent(this.keywords) } });
        } else {
          this.$router.push({ name: 'English' });
        }
      } else {
        if (this.keywords) {
          this.$router.push({ name: 'Index', query: { keywords: encodeURIComponent(this.keywords) } });
        } else {
          this.$router.push({ name: 'Index' });
        }
      }
    }
  }
}
</script>
<style lang="scss">
// 弹框与遮罩挂载到 body，使用独立类名限定样式，避免影响其他弹框。
.cf40-password-dialog-mask.v-modal { opacity: .3; }
.cf40-password-dialog-wrap {
  display: flex;
  padding: 24px 16px;
  box-sizing: border-box;
  .cf40-password-dialog {
    display: flex;
    flex-direction: column;
    min-height: 480px;
    max-width: 100%;
    margin: auto !important;
    border-radius: 6px;
    box-shadow: 0 4px 52px rgba(190, 208, 227, .4);
    font-family: HarmonyOS_Sans_Regular, "Microsoft YaHei", sans-serif;
    .el-dialog__header { padding: 36.5px 35px 0; }
    .el-dialog__title {
      display: block;
      color: #1e1e1e;
      font-size: 20px;
      font-weight: 500;
      line-height: 26px;
    }
    .el-dialog__body { padding: 36px 35px 0; }
    .el-form-item { margin-bottom: 29.5px; }
    .el-form-item__label {
      display: block;
      padding: 0;
      color: #1e1e1e;
      font-size: 13px;
      line-height: 33.5px;
    }
    .el-form-item__content { line-height: 38px; }
    .el-input { display: block; }
    .el-input__inner {
      display: block;
      height: 38px;
      padding: 0 38px 0 23px;
      border: 1px solid #e9e9e9;
      border-radius: 8px;
      background: #fcfafa;
      color: #1e1e1e;
      font-family: inherit;
      font-size: 12px;
      line-height: 38px;
      &::placeholder { color: #bbb; }
      &:hover { border-color: #bbb; }
      &:focus { border-color: #ed6f33; }
    }
    .el-input__suffix { right: 9px; }
    .el-form-item.is-error .el-input__inner { border-color: #f56c6c; }
    .el-form-item__error { line-height: 16px; }
    .el-dialog__footer { margin-top: auto; padding: 0 35px 27px; }
  }
}
.cf40-password-close, .cf40-password-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #bbb;
  cursor: pointer;
  svg { width: 16px; height: 16px; stroke: currentColor; stroke-width: 1.2; }
  &:hover { color: #ed6f33; }
  &:focus-visible { outline: 2px solid #ed6f33; outline-offset: 2px; }
}
.cf40-password-close {
  position: absolute;
  top: 22px;
  right: 23px;
  width: 20px;
  height: 20px;
  svg { width: 20px; height: 20px; }
}
.cf40-password-toggle { width: 24px; height: 38px; vertical-align: top; }
.cf40-password-required { color: #ed6f33; }
.cf40-password-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  .el-button {
    width: 134px;
    height: 39px;
    padding: 0 12px;
    border-color: #bbb;
    border-radius: 6px;
    color: #777;
    font-family: inherit;
    font-size: 16px;
    font-weight: 400;
    & + .el-button { margin-left: 0; }
    &:hover, &:focus { border-color: #ed6f33; background: #fff7f2; color: #ed6f33; }
    &--primary {
      border-color: #ed6f33;
      background: #ed6f33;
      color: #fff;
      &:hover, &:focus { border-color: #f7844d; background: #f7844d; color: #fff; }
    }
  }
}
@media screen and (max-width: 440px) {
  .cf40-password-dialog-wrap .cf40-password-dialog {
    .el-dialog__header { padding-left: 24px; padding-right: 24px; }
    .el-dialog__body { padding-left: 24px; padding-right: 24px; }
    .el-dialog__footer { padding-left: 24px; padding-right: 24px; }
    .el-input__inner { padding-left: 12px; }
  }
}
</style>
<style lang="scss" scoped>
.en-font {
  font-family: Georgia;
}
.en-font-bold {
  font-family: Georgia_Bold;
}
.cn-font {
  font-family: HarmonyOS_Sans_Regular;
}
.cn-font-bold {
  font-family: HarmonyOS_Bold;
}
.roboto-light {
  font-family: Roboto_Light;
}
.roboto-bold {
  font-family: Roboto_Bold;
}
.web-header {
  &-top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #ebeef0;
    &-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      &-card {
        display: flex;
        align-items: center;
        &-link {
          color: #757575;
          text-decoration: none;
          display: flex;
          align-items: center;
          &-icon {
            width: 30px;
            line-height: 0;
            display: inline-block;
          }
          &-text {
            margin: 0 20px 0 10px;
            color: #757575;
          }
        }
        &-switch {
          width: 26px;
          height: 26px;
          line-height: 26px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          color: #ffffff;
          text-decoration: none;
          background-color: #ed6f33;
        }
      }
    }
  }
  &-content {
    padding: 30px 0;
    border-bottom: 1px solid #ededed;
    &-box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-cn_logo {
        max-width: 206px;
      }
      &-en_logo {
        max-width: 152px;
      }
      &-opera {
        max-width: 620px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-search {
          margin-right: 15px;
          ::v-deep {
            .el-input__inner {
              height: 40px;
              line-height: 40px;
              border-radius: 40px;
              background-color: #E9E9E9;
              &:focus {
                border-color: #ed6f33;
              }
              &::placeholder {
                color: #899BA6;
              }
            }
            .el-input__prefix {
              color: #899BA6;
            }
          }
        }
        &-user {
          display: flex;
          align-items: center;
          .account-area { position: relative; }
          .account-link {
            border: 0;
            background: none;
            padding: 8px 0;
            cursor: pointer;
            font-family: inherit;
            display: flex;
            align-items: center;
            gap: 8px;
            color: #606266;
            text-decoration: none;
            font-size: 15px;
            &:hover, &:focus { color: #ed6f33; }
            .account {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 180px;
            }
          }
          &-link {
              word-break: keep-all;
              user-select: none;
              cursor: pointer;
              display: flex;
              align-content: center;
              &:hover {
                color: #ed6f33;
              }
            }
        }
        &-login, &-subscribe {
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 10px;
          font-size: 14px;
          border: 2px solid #ed6f33;
          user-select: none;
          white-space: nowrap;
          &:hover {
            border-color: #f38a58;
            background-color: #f38a58;
          }
        }
        &-login {
          color: #ed6f33;
          &:hover {
            color: #ffffff;
          }
        }
        &-subscribe {
          color: #ffffff;
          margin-left: 15px;
          background-color: #ed6f33;
        }
        ::v-deep {
          .el-dropdown {
            cursor: pointer;
            font-size: 16px;
          }
        }
      }
    }
  }
  &.en-font {
    .web-header-content-box-opera-subscribe {
      margin-left: 15px;
    }
    .web-header-content-box-opera-search {
      margin-right: 15px;
    }
  }
}
.account-panel-wrap {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 2000;
  padding-top: 10px;
  width: 400px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
}
.account-panel {
  padding: 20px 22px 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, .12);
  color: #333;
  h2 { margin: 0 0 14px; font-size: 17px; font-weight: 500; }
}
.account-information {
  margin: 0;
  font-size: 14px;
  > div { display: flex; gap: 12px; padding: 9px 0; line-height: 1.6; }
  dt { flex: 0 0 92px; color: #909399; }
  dd { margin: 0; min-width: 0; overflow-wrap: anywhere; }
}
.en-font .account-information dt { flex-basis: 138px; }
.account-actions {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ebeef5;
  margin-top: 12px;
  .el-button { color: #ed6f33; font-size: 14px; }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .web-header {
    &-top {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
    &-content {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .web-header {
    &-top {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
      }
    }
    &-content {
      &-box {
        width: calc(100% - 60px);
        padding: 0 30px;
        flex-direction: column;
        &.is-login {
          flex-direction: column;
        }
        &-cn_logo {
          max-width: 150px;
        }
        &-en_logo {
          max-width: 100px;
        }
        &-opera {
          margin-top: 25px;
          width: 100%;
          max-width: 100%;
          &-search {
            width: 60%;
            margin-right: 10px;
            ::v-deep {
              .el-input__inner {
                height: 34px;
                line-height: 34px;
                border-radius: 34px;
              }
            }
          }
          &-user {
            display: flex;
            align-items: center;
            &-link {
              white-space: nowrap;
            }
          }
          &-login, &-subscribe {
            padding: 8px 10px;
            font-size: 12px;
          }
          &-subscribe {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>

<style scoped>
.initial-password-notice { padding: 10px 24px; background: #fff3e8; color: #9c4b1d; text-align: center; font-size: 14px; }
</style>
